import { FilterContext } from 'contexts/FilterContext';
import { useContext } from 'react';

export function useFilter() {
  const context = useContext(FilterContext);

  return context;
}
